import { render, staticRenderFns } from "./AbortionEvent.vue?vue&type=template&id=2dadcb4a&scoped=true&"
import script from "./AbortionEvent.vue?vue&type=script&lang=js&"
export * from "./AbortionEvent.vue?vue&type=script&lang=js&"
import style0 from "./AbortionEvent.vue?vue&type=style&index=0&id=2dadcb4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dadcb4a",
  null
  
)

export default component.exports